import Image from "next/image";
import MarqueeHeading from "./common/MarqueeHeading";
import SpaceWrapper from "./common/SpaceWrapper";

const IdeateSection = () => (
  <SpaceWrapper className="!p-0">
    <div className="hidden md:block">
      <MarqueeHeading
        marqueeTitle={"IDEATE"}
        paragraph="We made this visual representation to map out each & every step the user will take from the entry point to the final point. It helped us to understand how a user will get navigation throughout the app & what possible decisions they can make while using it."
        smallTitle={"Ideate"}
      />
    </div>
    <div className="px-6 md:px-0 md:bg-roaddy-ideate-section bg-no-repeat bg-cover">
      <h3 className="font-bold text-3xl md:text-4xl text-white md:ml-8 xl:ml-48 relative md:top-16 flex">
        <div className="pr-4">
          <Image
            alt="star"
            loading="lazy"
            src="/assets/case-study/roaddy/blue-star.webp"
            width={35}
            height={35}
          />
        </div>
        <span>User Flow</span>
      </h3>
      <div className="flex justify-center md:px-8 xl:md-0 pb-24">
        <div className="mt-8 fs-0">
          <Image
            alt="Image showing flow of the user on roadside service app"
            loading="lazy"
            src="/assets/case-study/roaddy/ideate.webp"
            width={960}
            height={1191}
          />
        </div>
      </div>
    </div>
  </SpaceWrapper>
);
export default IdeateSection;
